<template>
  <Button
    data-slot="carousel-previous"
    :disabled="!canScrollPrev"
    :class="
      cn(
        'tw:touch-manipulation tw:absolute tw:size-8 tw:rounded-full tw:p-0',
        orientation === 'horizontal'
          ? 'tw:-left-12 tw:top-1/2 tw:-translate-y-1/2'
          : 'tw:-top-12 tw:left-1/2 tw:-translate-x-1/2 tw:rotate-90',
        props.class,
      )
    "
    variant="outline"
    size="icon"
    @click="scrollPrev"
  >
    <slot>
      <ArrowLeft class="tw:icon-action" />
      <span class="tw:sr-only">{{ t('common.previousImage') }}</span>
    </slot>
  </Button>
</template>

<script setup>
// 1. Import necessary components
defineOptions({ name: 'UiCarouselPrevious' });
import { ArrowLeft } from '@lucide/vue';
import { useI18n } from 'vue-i18n';
import { Button } from '@/shared/components/ui/button';
import { cn } from '@/shared/utilities/classes';
import { useCarousel } from './useCarousel';

// 2. Use
const props = defineProps({
  class: {
    default: undefined,
    type: [Boolean, null, String, Object, Array],
    required: false,
    skipCheck: true,
  },
});

const { canScrollPrev, orientation, scrollPrev } = useCarousel();
const { t } = useI18n();
// 3. Define a reactive variable
// 4. Define methods or computed properties if needed
// 5. VueJS Hooks
</script>
